import { useContext, useState } from "react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import CountDownTimer from "./CountDownTimer";
import { UserContext } from "../../context/UserContext";
import { useCloseField } from "../../Store/MenuSlice";
import { useIsVerified } from "../../Store/useStore";
import { authAxios } from "../../Axios/createAxios";
export default function VerifyUser({ route }) {
  const is = useIsVerified();
  const queryClient = useQueryClient();
  const [otp, setOtp] = useState("_".repeat(5));
  const close = useCloseField();
  const resendCode = async () => {
    try {
      const res = await authAxios.post(`/send/verify-user/code`, {});
      console.log(res);
      return res;
    } catch (e) {
      console.log(e);
    }
  };
  const data = async () => {
    try {
      const res = await authAxios.post(`/email/register`, { otp });
      return res;
    } catch (er) {
      throw er;
    }
  };

  const { mutate, error, isLoading, isSuccess, isError, reset } = useMutation({
    mutationFn: data,
    onSuccess: (data) => {
      console.log(data);
      close("isVerified");
      queryClient.invalidateQueries("profile");
      reset();
    },
    onError: () => setOtp("_".repeat(5)),
  });

  const handleInputChange = (e) => {
    let value = e.target.value;
    value = value.replace(/\D/g, "");
    value = value.padStart(5, "_");
    value = value.slice(0, 5);
    console.log(typeof value);
    setOtp(value);
  };

  const onSub = (e) => {
    e.preventDefault();
    const transOtp = Number(otp);
    if (!Number.isInteger(transOtp)) return;

    if (isLoading) return;
    console.log(otp);

    mutate();
  };
  // if (userInfo.email_verified_at !== null) return;
  return (
    <div
      className={`prime-bg-c fixed index-29 full-w page-h d-flex flex-center align-items-center flex-column `}
      style={!is && !route ? { visibility: "hidden" } : {}}>
      <h6>verify code</h6>
      <div
        className="otp-code radius-8 p-20"
        style={{
          maxWidth: "400px",
        }}>
        <input
          placeholder="Enter OTP"
          className={`p-10 full-w mb-10 radius-4 txt-center`}
          value={otp}
          name="otp"
          type="text"
          onInput={handleInputChange}
        />
        <button
          disabled={isNaN(Number(otp))}
          type="submit"
          onClick={onSub}
          style={{
            opacity: isNaN(Number(otp)) ? "0.5" : "1",
            pointerEvents: isNaN(Number(otp)) ? "none" : "",
            width: "100%",
          }}
          className="radius-4 p-10 full-w succ-bg-c">
          {isLoading ? "loading..." : "Submit"}
        </button>

        <CountDownTimer
          request={resendCode}
          className={`p-10 mt-10 radius-4 full-w full-button-mixed`}
          innerText={"Resend code"}
        />

        {isError && !isLoading && <p className="err-c txt-center">Invalid Verify code</p>}
      </div>
    </div>
  );
}
